import React from "react";
import styled from "styled-components";
import { device } from "../../../styles/BreakPoints";

const MailBar = () => {
  return (
    <Container>
      <Wraper>
        <a href="mailto:tusharahmmedsakib@gmail.com">
          tusharahmmedsakib@gmail.com
        </a>
      </Wraper>
    </Container>
  );
};

export default MailBar;

const Container = styled.div`
  width: 40px;
  position: fixed;
  bottom: 0px;
  left: auto;
  right: 40px;
  z-index: 10;
  color: var(--light-slate);

  @media ${device.lg} {
    left: auto;
    right: 20px;
  }
  @media ${device.mdM} {
   display: none;
  }
`;
const Wraper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  
  &::after{
    content: "";
    display: block;
    width: 1px;
    height: 90px;
    margin: 0px auto;
    background-color: var(--light-slate);
    margin-top: 50px;
  }
  a {
    margin: 20px auto;
    padding: 10px;
    font-family: ${(props)=> props.theme.fonts.sf};
    font-size: var(--fz-xs);
    line-height: var(--fz-lg);
    letter-spacing: 0.1em;
    writing-mode: vertical-rl;
    transition: var(--transition);

    &:hover {
      color: var(--green);
      transform: translateY(-3px);
    }
  }
`;
